import { Container } from "../../../../components/formulario/styled"
import HeaderVisitante from "./header"
import TabelaVisitante from "./tabela"


const ContainerAcolherVisitante = () => {
  return (
    <Container>
      <HeaderVisitante/>
      <TabelaVisitante/>
    </Container>
  )
}

export default ContainerAcolherVisitante;
